import { MessageSquare } from 'lucide-react'
import { useMyIssues } from '../../hooks/useSystemIssues'
import { IssueRow } from '../shared/IssueRow'

interface MyIssuesListProps {
  onSelect: (issueId: number) => void
}

const thClass = 'px-4 py-2 font-medium'

/** Mesmo desenho de tabela de `TriageQueueList` (`IssueRow` compartilhado) —
 * sem `showReporterMeta`, já que aqui é sempre a lista do próprio usuário. */
export function MyIssuesList({ onSelect }: MyIssuesListProps) {
  const { data: issues = [], isLoading } = useMyIssues()

  if (isLoading) {
    return (
      <div className="p-4 text-center text-xs text-subtle">Carregando…</div>
    )
  }

  if (issues.length === 0) {
    return (
      <div className="flex flex-col items-center gap-2 p-8 text-center text-xs text-subtle">
        <MessageSquare className="h-8 w-8 opacity-40" />
        Você ainda não reportou nenhum problema.
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-border-subtle text-left text-[11px] uppercase tracking-wide text-subtle">
            <th className={thClass}>ID / Título / Processo</th>
            <th className={thClass}>Atribuído a</th>
            <th className={thClass}>Status</th>
            <th className={thClass}>Prioridade</th>
            <th className={thClass}>Aberto em</th>
            <th className={thClass}>Última mensagem</th>
            <th className={thClass}>
              <span className="sr-only">Não lidas</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border-subtle">
          {issues.map((issue) => (
            <IssueRow key={issue.id} issue={issue} onSelect={onSelect} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
